import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import { theme } from "@chakra-ui/core";
import { BrowserRouter } from "react-router-dom";
import { ThemeProvider, CSSReset } from "@chakra-ui/core";
import { createStore, StoreProvider } from "easy-peasy";
import model from "./model";
import { pdfjs } from "react-pdf";

pdfjs.GlobalWorkerOptions.workerSrc =
  "//cdnjs.cloudflare.com/ajax/libs/pdf.js/2.5.207/pdf.worker.js";

const customTheme = {
  ...theme,
  colors: {
    ...theme.colors,
    brand: {
      900: "#1a365d",
      800: "#153e75",
      700: "#2a69ac",
    },
  },
};
const store = createStore(model);

ReactDOM.render(
  <React.StrictMode>
    {/* <HashRouter> */}
    <BrowserRouter basename={process.env.PUBLIC_URL}>
      <StoreProvider store={store}>
        <ThemeProvider theme={customTheme}>
          <CSSReset />
          <App />
        </ThemeProvider>
      </StoreProvider>
    </BrowserRouter>
    {/* //   </HashRouter> */}
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
